import { type } from "../types/types";

export const set_coupons = (coupons) => (dispatch) => {
  dispatch({
    type: type.SET_COUPONS,
    coupons: coupons,
  });
};
